module.exports = __webpack_public_path__ + "img/smith-profilePix.95deb475.jpg";